import PropTypes from 'prop-types';

import Feed from 'core/components/Feed';
import ListPage from 'core/components/ListPage';
import PageLoader from 'core/components/Loader/PageLoader';

import modelPropTypes, {
  personAttributes,
} from 'core/utils/prop-types/model';

import AuthorCard from './AuthorCard';

import { limit } from 'core/queries/authorsPage';


/**
 * @author Aleksey Dibrivniy <a.dibrivniy@rambler-co.ru>
 */
function AuthorsPage(props) {
  const {
    rawAuthors,
    title,
    description,
    isLoading,
    ...feedProps
  } = props;

  return (
    <ListPage
      title={title}
      description={description}
      rawData={rawAuthors}
      limit={limit}
      isLoading={isLoading}
    >
      {({ content }) => {
        if (isLoading) return <PageLoader />;

        return (
          <div style={{ marginBottom: 20 }}>
            <Feed
              content={content}
              interitemSpacing={20}
              columns={2}
              grid
              card={AuthorCard}
              {...feedProps}
            />
          </div>
        );
      }}
    </ListPage>
  );
}

AuthorsPage.propTypes = {
  rawAuthors: PropTypes.shape({
    data: PropTypes.arrayOf(modelPropTypes(personAttributes)).isRequired,
    meta: PropTypes.object,
  }),
  /**
   * title передается в ListPage
   */
  title: PropTypes.string,
  /**
   * description передается в ListPage
   */
  description: PropTypes.string,

  /** Признак загрузки данных для передачи в ListPage */
  isLoading: PropTypes.bool,
};

AuthorsPage.defaultProps = {
  title: 'Авторы',
};

export { AuthorsPage };
export default AuthorsPage;
